export const SteeringWheelPresets = [0, -45, 45];
